// extracted by mini-css-extract-plugin
module.exports =  {"reviews":"a10a3f92e9--reviews--ax2je"};